import { render, staticRenderFns } from "./Factory_Carousel.vue?vue&type=template&id=12720ccc&scoped=true"
import script from "./Factory_Carousel.vue?vue&type=script&lang=js"
export * from "./Factory_Carousel.vue?vue&type=script&lang=js"
import style0 from "./Factory_Carousel.vue?vue&type=style&index=0&id=12720ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12720ccc",
  null
  
)

export default component.exports